import React, {useMemo, useEffect, useState} from "react";
import { useLocation } from 'react-router-dom';
import { Alert, Row, Col, Card, CardBody, Container, Input, Label } from "reactstrap";
import { withForm } from "components/common";
import { FormGroup, SaveButton, required } from "components/common";
import { compose, withState, withStateHandlers } from "recompose";
import { LocalForm, Control, actions, Errors } from "react-redux-form";
import { isEmail } from "validator";
import { Trans, withTranslation, useTranslation } from "react-i18next";
import countryList from 'react-select-country-list';
import Select from "react-select";
import { ApiClient, } from "services";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { NotificationManager } from "react-notifications";
import { useOrganisationContext } from "hooks";
import LoadingMsg from "components/common/LoadingMsg";
import { priceForRemainingDays } from "../../Helpers"
import { formatDateName } from "services/util";
import GetBack from "components/refactoring/BackButton";

const HelpText = ({ children }) => (
  <span className="form-text small text-danger">
    <Trans>{children}</Trans>
  </span>
);

const useSelection = () => {
  const [selectedItems, setSelectedItems] = useState([]);

  const handleToggle = (feature) => {
    console.log(feature);
    
    if (selectedItems.some(item => item.object_id === feature.object_id)) {
      setSelectedItems(selectedItems.filter(item => item.object_id !== feature.object_id));
    } else {
      setSelectedItems([...selectedItems, feature]);
    }
  };

  return [selectedItems, handleToggle];
};


export const EditSubscriptionFeature = ({
  item,
  form,
  setDispatch,
  onSubmit,
  onUpdate,
  onChange,
  dispatch,
  success,
  failure,
  match,
  t
}) => {

  const subscriptionId = match.params.id || 0

  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [redirecting, setRedirecting] = useState();
  const [currentSubscriptionData, setCurrentSubscriptionData] = useState({});

  const history = useHistory()
  const client = ApiClient()

  const [moduleData, setModuleData] = useState();
  const [applicationData, setApplicationData] = useState();
  const [languageData, setlanguageData] = useState();

  const [selectedLang, handleLanguageToggle] = useSelection();
  const [selectedMod, handleModToggle] = useSelection();
  const [selectedApp, handleAppToggle] = useSelection();

  useEffect(() => {

    const fetchModuleData = async () => {
      let params = {}
      
      try {
        setLoading(true)
        const responseApp = await client.get("core/hesaab_module", { params })
        setModuleData(responseApp.data)
        setLoading(false)
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false)
      }
    };

    fetchModuleData()

    const fetchData = async () => {
      try {
        setLoading(true)
        const responseL = await client.get("core/hesaab_language");
        const ldata = responseL.data;
        setlanguageData(ldata);
        setLoading(false)
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false)
      }
    };

    fetchData();

    const fetchApplicationData = async () => {
      try {
        setLoading(true)
        const responseApp = await client.get("core/hesaab_application")
        setApplicationData(responseApp.data)
        setLoading(false)
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false)
      }
    };

    fetchApplicationData()

    const fetchSubscriptionData = async () => {
      if (subscriptionId !== 0) {
        try {
          const res = await client.get(`subscriptions/${subscriptionId}`);
          const data = res.data;
          setCurrentSubscriptionData(data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    }  

    fetchSubscriptionData()

  }, [subscriptionId]);

  let currentPlan = currentSubscriptionData

  function snakeToTitle(str) {
    return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  const responseError = "No Response from the server, please try again"

  const handlePost = async () => {
    let selectedFeatures = [...selectedApp, ...selectedLang, ...selectedMod].map(feature => ({
      object_id: feature.id,
      content_type: feature.content_type,
      
    }))

    let postData = {
      features: selectedFeatures,
    }

    let endpoint = `/subscriptions/${currentPlan.id}/update-feature`

    client.post(endpoint, postData)
      .then(response => {
          NotificationManager.success(t('Subscription feature updated successfully'));
          setIsSending(false);

          setTimeout(() => {
            history.goBack()
          }, 500);
      })
      .catch(error => {
        console.error("Error:", error);
        if (error.response && error.response.data) {
          const errors = error.response.data;
          Object.entries(errors).forEach(([key, value]) => {
            const fieldName = snakeToTitle(key);
            const errorMessage = `${fieldName} - ${value}`;
            if (errorMessage === "Connected Organisation - Invalid pk \"0\" - object does not exist.") {
              NotificationManager.error(t("Your connected organisation cannot be determined"))
            } else {
            NotificationManager.error(errorMessage)
          }
          });
        } else {
          NotificationManager.error(t("An error occurred while saving"));
        }
        setIsSending(false);
      });
  };

  let purchasedLanguages = currentPlan?.subscribed_features?.filter(item => item.content_type_name === 'hesaablanguage').map(item => item.object_id)

  let purchasedApplications = currentPlan?.subscribed_features?.filter(item => item.content_type_name === 'hesaabapplication').map(item => item.object_id)

  let purchasedModules = currentPlan?.subscribed_features?.filter(item => item.content_type_name === 'hesaabmodule').map(item => item.object_id)

  const onChangeFeature = (feature, currentPlan, contentType) => {
    if (contentType === 'hesaablanguage') {
      handleLanguageToggle(feature)
    } else if (contentType === 'hesaabapplication') {
      handleAppToggle(feature)
    } else if (contentType === 'hesaabmodule') {
      handleModToggle(feature)
    }
  }

  const getPrice = (item, currentPlan) => {
    let priceInfo = currentPlan?.billing_cycle === 'Yearly' ? item.yearly_price : item.monthly_price

    if (!priceInfo) return '-'

    return `${priceInfo?.currency} ${priceInfo?.price}`
  }

  return (
  <div className='payment-summary'>
    <Container>
      <GetBack styleClass="my-2"></GetBack>
      <Row>
        <Col xs={false}>
          <Card>
            <CardBody>
                {redirecting ? <LoadingMsg message="Redirecting"/> :
                 <LocalForm
                    initialState={item}
                    onSubmit={values => handlePost(values)}
                    getDispatch={setDispatch}
                    onUpdate={onUpdate}
                    onChange={onChange}
                  >

                <Row>
                  <Col xs={12}>
                    <h4 className="mb-3">Update subscription</h4>

                      <Row>
                        <Col md="4" xs={false}>
                          <span className="d-print-none card-title">Modules</span>
                          <table className="table table-sm border" style={{maxWidth:"100%"}}>
                            <thead>
                              <tr>
                                  <th className="text-left"><Trans>Name</Trans></th>
                                  <th className="text-center"><Trans>{currentPlan?.plan_type} Price</Trans></th>
                                  <th className="text-right"><Trans>Select</Trans></th>
                              </tr>
                            </thead>
                            <tbody>
                              {moduleData?.map((i) => (
                                <tr key={i.id}>
                                  <td className="text-left">{i.name}</td>
                                  <td className="text-center">
                                    {
                                      getPrice(i, currentPlan)
                                    }
                                  </td>
                                  <td className="text-right">
                                    <Control.checkbox
                                      model={`.mod-${i.id}`}
                                      checked={selectedMod.includes(i.id)}
                                      onChange={() => onChangeFeature(i, currentPlan, 'hesaabmodule')}
                                      disabled={!!purchasedModules?.includes(i.id)}
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </Col>
                        <Col md="4" xs={false}>
                          <span className="d-print-none card-title">Languages</span>
                          <table className="table table-sm border" style={{maxWidth:"100%"}}>
                            <thead>
                              <tr>
                                <th className="text-left"><Trans>Name</Trans></th>
                                <th className="text-center"><Trans>{currentPlan?.plan_type} Price</Trans></th>
                                <th className="text-right"><Trans>Select</Trans></th>
                              </tr>
                            </thead>
                            <tbody>
                            {languageData?.map((i) => (
                                <tr key={i.id}>
                                    <td className="text-left">{i.name}</td>
                                    <td className="text-center">
                                      { 
                                        getPrice(i, currentPlan)
                                      }
                                    </td>
                                    <td className="text-right">
                                      <Control.checkbox 
                                        model={`.lang-${i.id}`}
                                        checked={selectedLang.includes(i.id)}
                                        onChange={() => onChangeFeature(i, currentPlan, 'hesaablanguage')}
                                        disabled={!!purchasedLanguages?.includes(i.id)}
                                      />
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                          </table>
                        </Col>
                        <Col md="4" xs={false}>
                            <span className="d-print-none card-title">Applications</span>
                            <table className="table table-sm border" style={{maxWidth:"100%"}}>
                            <thead>
                            <tr>
                                <th className="text-left"><Trans>Name</Trans></th>
                                <th className="text-center"><Trans>{currentPlan?.plan_type} Price</Trans></th>
                                <th className="text-right"><Trans>Select</Trans></th>
                            </tr>
                            </thead>
                            <tbody>
                            {applicationData?.map((i) => (
                                <tr key={i.id}>
                                    <td className="text-left">{i.name}</td>
                                    <td className="text-center">
                                      { 
                                        getPrice(i, currentPlan)
                                      }
                                    </td>
                                    <td className="text-right">
                                      <Control.checkbox 
                                        model={`.app-${i.id}`}
                                        checked={selectedApp.includes(i.id)}
                                        onChange={() => onChangeFeature(i, currentPlan, 'hesaabapplication')}
                                        disabled={!!purchasedApplications?.includes(i.id)}
                                      />
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        </Col>
                      </Row>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12}>
                    <FormGroup className="mt-4">
                      <SaveButton
                        type="submit"
                        className="btn-primary-filled btn-rounded btn-form-submit btn-rounded float-right"
                        form={form}
                      >
                        <Trans>Save</Trans>
                      </SaveButton>
                    </FormGroup>
                  </Col>
                </Row>
              </LocalForm>}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  </div>

)
};

const enhance = compose(
  withTranslation(),
  withState("success", "setSuccess", null),
  withState("failure", "setFailure", null),
  withStateHandlers(
    {},
  )
);

export default enhance(EditSubscriptionFeature);
